export default class Alert {
    constructor(content, type) {
        this.content = content;
        this.type = type;
    }
}